import React, { Suspense, lazy } from 'react';
import { Hero } from './components/Hero';

/**
 * Everything below the first viewport is code-split so the Hero (LCP) ships
 * with the smallest possible JS payload. Each block reserves vertical space
 * while its chunk loads, which keeps CLS at zero.
 */
const PainSection = lazy(() => import('./components/PainSection').then(m => ({
  default: m.PainSection
})));
const PositioningSection = lazy(() => import('./components/PositioningSection').then(m => ({
  default: m.PositioningSection
})));
const TomosSection = lazy(() => import('./components/TomosSection').then(m => ({
  default: m.TomosSection
})));
const BenefitsSection = lazy(() => import('./components/BenefitsSection').then(m => ({
  default: m.BenefitsSection
})));
const AudienceSection = lazy(() => import('./components/AudienceSection').then(m => ({
  default: m.AudienceSection
})));
const TransformationSection = lazy(() => import('./components/TransformationSection').then(m => ({
  default: m.TransformationSection
})));
const BonosSection = lazy(() => import('./components/BonosSection').then(m => ({
  default: m.BonosSection
})));
const OfferSection = lazy(() => import('./components/OfferSection').then(m => ({
  default: m.OfferSection
})));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const FaqSection = lazy(() => import('./components/FaqSection').then(m => ({
  default: m.FaqSection
})));
const FinalCta = lazy(() => import('./components/FinalCta').then(m => ({
  default: m.FinalCta
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const StickyBuyBar = lazy(() => import('./components/StickyBuyBar').then(m => ({
  default: m.StickyBuyBar
})));
interface DeferredProps {
  children: React.ReactNode;
  minHeight: string;
  background?: string;
}
function Deferred({
  children,
  minHeight,
  background = 'bg-ivory'
}: DeferredProps) {
  return <Suspense fallback={<div className={`w-full ${background}`} style={{
    minHeight
  }} aria-hidden data-id="element-1" data-mp="356rh3pi3e8j" />} data-id="element-0" data-mp="35oy8u9shaup">
      {children}
    </Suspense>;
}
export function App() {
  return <main className="w-full bg-ivory text-charcoal" data-id="element-2" data-mp="d4e4tqw8j8vn">
      <Hero data-id="element-3" data-mp="d3wd97kipiu2" />
      <Deferred minHeight="560px" data-id="element-4" data-mp="d2l7x3bfc30u">
        <PainSection data-id="element-5" data-mp="851l3f0nuhxa" />
      </Deferred>
      <Deferred minHeight="560px" background="bg-sand" data-id="element-6" data-mp="864atjm8yebm">
        <PositioningSection data-id="element-7" data-mp="3gkv17sr2xrdt" />
      </Deferred>
      <Deferred minHeight="1100px" data-id="element-8" data-mp="3glwabrojc3sw">
        <TomosSection data-id="element-9" data-mp="3bmbfntgeehlz" />
      </Deferred>
      <Deferred minHeight="620px" background="bg-sand" data-id="element-10" data-mp="3bncorsdusu12">
        <BenefitsSection data-id="element-11" data-mp="3qb7klhn5reid" />
      </Deferred>
      <Deferred minHeight="560px" data-id="element-12" data-mp="3qc948ai8p9bp">
        <AudienceSection data-id="element-13" data-mp="3qdakcte44m0a" />
      </Deferred>
      <Deferred minHeight="520px" background="bg-charcoal" data-id="element-14" data-mp="3ljxyus4qcvbr">
        <TransformationSection data-id="element-15" data-mp="3limrkic2t5fw" />
      </Deferred>
      <Deferred minHeight="620px" background="bg-sand" data-id="element-16" data-mp="2xtv5m8p2xjbk">
        <BonosSection data-id="element-17" data-mp="2xsk64l2o2xq9" />
      </Deferred>
      <Deferred minHeight="560px" background="bg-sand" data-id="element-18" data-mp="2suqxzmhsztnc">
        <OfferSection data-id="element-19" data-mp="2stzakyyd1285" />
      </Deferred>
      <Deferred minHeight="240px" background="bg-sand" data-id="element-20" data-mp="18dhu6akcxc96">
        <GuaranteeSection data-id="element-21" data-mp="18by986nrad12" />
      </Deferred>
      <Deferred minHeight="520px" data-id="element-22" data-mp="1d5jb49sgzr5j">
        <FaqSection data-id="element-23" data-mp="1d5suhej0f029" />
      </Deferred>
      <Deferred minHeight="420px" background="bg-sand" data-id="element-24" data-mp="yfv6ozozscdl">
        <FinalCta data-id="element-25" data-mp="yheq2z5y33jl" />
      </Deferred>
      <Deferred minHeight="380px" background="bg-sand" data-id="element-26" data-mp="13eewxcamcabr">
        <Footer data-id="element-27" data-mp="13ey4bz2n7gbj" />
      </Deferred>
      <Suspense fallback={null} data-id="element-28" data-mp="1r496nkzn5irs">
        <StickyBuyBar data-id="element-29" data-mp="1r5al7zfv8ne9" />
      </Suspense>
    </main>;
}